import React, { memo, useEffect, useMemo, useState } from 'react'
import HalspanContainer from '@components/Container';
import PageBanner from '@components/PageBanner';
import RibbonTemplate from '@components/RibbonTemplate';
import Facade from '@whitecobalt/tungsten/esm/components/Facade';
import Icon from '@whitecobalt/tungsten/esm/components/Icon';
import FileKeyLoader from '@whitecobalt/tungsten/esm/components/FileKeyLoader';
import { useScreenTitle } from '@whitecobalt/tungsten/hooks/useScreenTitle'
import { useLazyQuery } from '@apollo/client';
import ProductThumbnail from '../../Prefabs/ProductThumbnail';
import { ShopProductHardwareQuery, ShopProductHardwareQueryType } from '@services/query/EcommerceQueries';
import { emptyArray } from '@whitecobalt/tungsten/esm/common/utils/assets';
import ProductFilter from '../../Prefabs/ProductFilter';
import  useWindowDimensions  from '@utils/getWindowDimensions'
import HalspanButton from '@components/Button';
import { NavDropdown } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import Image from '@whitecobalt/tungsten/esm/components/Image'
import FormManager from '@whitecobalt/tungsten/esm/components/FormManager';
import SelectDropdown from '@whitecobalt/tungsten/esm/components/Fields/SelectDropdown';

interface AllHardwareListProps {
	menuDescription?: string;
    shopLinks: {
        label: string;
        value: string;
    }[]
    productTypeURL?: string;
    productCategoryURL?: string;
}

interface DataGroupProps {
    Product : {
        ID: number;
        DisplayName : string;
        ProductImages: {
            ImageUrl: string;
        }[];
        URL: string;
    }
}


const productGroupInitialData : DataGroupProps[] = [
    {
        Product: {
            ID: 3,
            DisplayName: "Closers",
            ProductImages: [{ImageUrl:'/images/store/closers.jpg'}],
            URL: '/store/hardware/closers'
        },
    },
    {
        Product: {
            ID: 5,
            DisplayName: "Hinges",
            ProductImages: [{ImageUrl:'/images/store/hinges.jpg'}],
            URL: '/store/hardware/hinges'
        },
    },
    {
        Product: {
            ID: 4,
            DisplayName: "Locks",
            ProductImages: [{ImageUrl:'/images/store/locks.jpg'}],
            URL: '/store/hardware/locks'
        },
    }, 
    {
        Product: {
            ID: 19,
            DisplayName: "Cylinders",
            ProductImages: [{ImageUrl:'/images/store/cylinders.png'}],
            URL: '/store/hardware/cylinders'
        },
    },
    {
        Product: {
            ID: 20,
            DisplayName: "Handles / Finger Plates",
            ProductImages: [{ImageUrl:'/images/store/handles.jpg'}],
            URL: '/store/hardware/handles-finger-plates'
        },
    },
    {
        Product: {
            ID: 8,
            DisplayName: "Letterplates",
            ProductImages: [{ImageUrl:'/images/store/letterplates.png'}],
            URL: '/store/hardware/letterbox'
        },
    },
    {
        Product: {
            ID: 9,
            DisplayName: "Ancillary Items",
            ProductImages: [{ImageUrl:'/images/store/ancillary.jpg'}],
            URL: '/store/hardware/ancillary-items'
        },
    },
]

const AllHardwareList: React.FunctionComponent<AllHardwareListProps> = memo(({menuDescription, shopLinks, productTypeURL, productCategoryURL}) => {
    const title = 'All Hardware'
    const [productGroups, setProductGroups]  = useState<DataGroupProps[]>(productGroupInitialData)
    const { height, width } = useWindowDimensions();
    const history = useHistory()
    useScreenTitle(`Halspan Store - ${title}`);
	const variables = {
		request: {
            ProductTypeIDs: [ 8, 20, 9, 3, 4, 5 ],
		},
		order: { Product: { Name: "ASC" }}
	}

	useEffect(() => {
		loadProducts({
			variables
		})
	}, [])

    const [loadProducts, request] = useLazyQuery<ShopProductHardwareQueryType>(ShopProductHardwareQuery, {
		fetchPolicy: 'no-cache'
	})

    const data = request.data?.ShopProductHardware.items || emptyArray

	const fileKeys = useMemo(() => {
		return data.filter((each) => !!each.Product.ProductImages[0]?.ImageUrl).map((each) => {
			return each.Product.ProductImages[0]?.ImageUrl
		})
	}, [data])

	const multiFetchPayload = useMemo(() => ({
		"maxWidthInPX": 175,
		"maxHeightInPX": 175,
	}), [])

    return (
		<>
			<div className="row">
				<div className="col-md-3 wc-sidebar-menu wc-products-home-side-menu wc-search-products">
                    <ProductFilter 
                        shopLinks={shopLinks}
                        productTypeName="Hardware"
                        productCategory={title}
                        menuDescription={menuDescription}
                        productTypeURL={productTypeURL}
						productCategoryURL={productCategoryURL}
                        onChange={(events) => {}} 
                    />
				</div>
				<div className="col-md-9">
					<div className="row">
						<FileKeyLoader.MultiFetch
							fileKeys={fileKeys}
							payload={multiFetchPayload}
							cache
							cacheUniqueString="175px"
						>
							{productGroups.length > 0 ? productGroups.map((item, index) => {
								return (
									<div key={index} className="col-sm-6 col-lg-4 col-xl-3">
                                            <Link className="product-thumbnail" to={item.Product.URL}>
                                                <h4 className="product-thumbnail-title">{item.Product.DisplayName}</h4>
                                                {(item?.Product?.ProductImages[0]?.ImageUrl) ? 
                                                    (
                                                        <img
                                                            src={item?.Product?.ProductImages[0]?.ImageUrl}
                                                            alt="halspan coming soon"
                                                        />
                                                    ) :(
                                                        <img
                                                            src="/images/coming-soon.png"
                                                            alt="halspan coming soon"
                                                        />
                                                    )
                                                }
                                            </Link>
									</div>
								)
							}) : request.loading ? (
								new Array(8).fill(0).map((_: any, index) => (
									<div key={index} className="col-sm-6 col-lg-4 col-xl-3 wc-product-search-item">
										<div className="product-thumbnail">
											<h4><Facade title rows={0} padding={false} rowListStyle={{margin: 0}} /></h4>
											<Facade rows={1} padding={false} rowListStyle={{margin: 0}} rowStyle={{ borderRadius: 0, width: '100%', height: 150}} />
										</div>
									</div>
								))
							) : (
								<div className="d-flex justify-content-center w-100">
									<div className="text-center my-5">
										<Icon name="inbox" size={25}/>
										<h4 className="mt-2">No {title} to display</h4>
									</div>
								</div>
							)}
						</FileKeyLoader.MultiFetch>
					</div>
				</div>
			</div>   
		</>
    )
})

export default AllHardwareList